
function updateCartQuantity(line, quantity) {
  if (quantity < 1) {
    removeFromCart(line);
    return;
  }
  
  const itemElement = document.querySelector(`[data-line="${line}"]`);
  const itemKey = itemElement ? itemElement.dataset.itemKey : null;
  
  if (!itemKey) {
    console.error('Item key not found, using line method');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: parseInt(quantity) })
    })
    .then(response => response.json())
    .then(data => {
      location.reload(); 
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      location.reload();
    });
    return;
  }
  
  const quantityInput = itemElement.querySelector('.cart-quantity-number');
  if (quantityInput) quantityInput.disabled = true;
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: parseInt(quantity) })
  })
  .then(response => response.json())
  .then(data => {
    if (data.item_count === 0) {
      location.reload();
    } else {
      updateCartUI(data);
      // Update cart count in header if function exists
      if (typeof updateCartCount === 'function') {
        updateCartCount();
      }
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    location.reload();
  })
  .finally(() => {
    // Re-enable input
    if (quantityInput) quantityInput.disabled = false;
  });
}

function changeQuantity(line, change, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  const input = document.querySelector(`[data-line="${line}"] .cart-quantity-number`);
  const currentQty = parseInt(input.value);
  const newQty = currentQty + change;
  
  if (newQty < 1) {
    removeFromCart(line);
    return;
  }
  
  input.value = newQty;
  updateCartQuantity(line, newQty);
}

function removeFromCart(line, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  if (confirm('Are you sure you want to remove this item?')) {
    const itemElement = document.querySelector(`[data-line="${line}"]`);
    const itemKey = itemElement ? itemElement.dataset.itemKey : null;
    
    if (!itemKey) {
      console.error('Item key not found, using line method');
      // Fallback to line-based removal
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(response => response.json())
      .then(data => {
        location.reload(); // Reload to show changes
      })
      .catch(error => {
        console.error('Error removing item:', error);
        location.reload();
      });
      return;
    }
    
    // Disable the button to prevent multiple clicks
    const deleteBtn = itemElement.querySelector('.cart-delete-btn');
    if (deleteBtn) deleteBtn.disabled = true;
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(response => response.json())
    .then(data => {
      if (data.item_count === 0) {
        location.reload();
      } else {
        // Remove the item from DOM
        itemElement.remove();
        updateCartUI(data);
        // Update cart count in header if function exists
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }
      }
    })
    .catch(error => {
      console.error('Error removing item:', error);
      // Re-enable button on error
      if (deleteBtn) deleteBtn.disabled = false;
      location.reload();
    });
  }
}

function updateCartUI(cartData) {
  // Update cart totals
  const subtotalElements = document.querySelectorAll('[data-cart-subtotal]');
  const totalElements = document.querySelectorAll('[data-cart-total]');
  
  subtotalElements.forEach(el => {
    el.textContent = formatMoney(cartData.total_price);
  });
  
  totalElements.forEach(el => {
    el.textContent = formatMoney(cartData.total_price);
  });
  
  // Update order summary
  const orderSummary = document.querySelector('.order-list');
  if (orderSummary && cartData.items) {
    let summaryHTML = '';
    cartData.items.forEach(item => {
      summaryHTML += `
        <li>
          <p><span>x${item.quantity}</span>${item.product_title.substring(0, 25)}</p>
          <p><strong>${formatMoney(item.final_line_price)}</strong></p>
        </li>
      `;
    });
    orderSummary.innerHTML = summaryHTML;
  }
  
  // Update individual item prices and quantities
  cartData.items.forEach((item, index) => {
    const lineNumber = index + 1;
    const itemElement = document.querySelector(`[data-line="${lineNumber}"]`);
    if (itemElement) {
      const priceElement = itemElement.querySelector('.cart-product-price strong');
      const quantityInput = itemElement.querySelector('.cart-quantity-number');
      
      if (priceElement) {
        priceElement.textContent = formatMoney(item.final_price);
      }
      if (quantityInput) {
        quantityInput.value = item.quantity;
      }
    }
  });
}

function formatMoney(cents) {
  return new Intl.NumberFormat('en-BD', {
    style: 'currency',
    currency: 'BDT',
    minimumFractionDigits: 0
  }).format(cents / 100);
}

function applyDiscountCode(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  const discountCode = document.getElementById('discount-code').value.trim();
  if (discountCode) {
    window.location.href = `/discount/${discountCode}`;
  } else {
    alert('Please enter a discount code');
  }
}

// Initialize cart page functionality
document.addEventListener('DOMContentLoaded', function() {
  // Debug: Log cart items on page load
  console.log('Cart items found:', document.querySelectorAll('[data-line]').length);
  document.querySelectorAll('[data-line]').forEach(item => {
    console.log('Item:', item.dataset.line, 'Key:', item.dataset.itemKey);
  });
  
  // Prevent enter key in quantity inputs
  const quantityInputs = document.querySelectorAll('.cart-quantity-number');
  quantityInputs.forEach(input => {
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        this.blur();
      }
    });
    
    // Handle input change
    input.addEventListener('change', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const line = this.closest('[data-line]').getAttribute('data-line');
      console.log('Quantity changed for line:', line, 'New value:', this.value);
      updateCartQuantity(parseInt(line), this.value);
    });
  });
  
  // Prevent any button clicks from opening sidebar
  const cartButtons = document.querySelectorAll('.cart-quantity-decrease, .cart-quantity-increase, .cart-delete-btn');
  cartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Button clicked:', this.className);
    });
  });
  
  // Add click handlers for delete buttons specifically
  const deleteButtons = document.querySelectorAll('.cart-delete-btn');
  deleteButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const line = this.closest('[data-line]').getAttribute('data-line');
      console.log('Delete button clicked for line:', line);
      removeFromCart(parseInt(line), e);
    });
  });
});